export interface LocationMapAddressFields {
  address: string;
  city: string;
  postalCode: string;
  country: string;
}

export interface LocationMapCoordinates {
  latitude: number;
  longitude: number;
}

// toFixed(6) round-trips (form ↔ map) can differ from the source float by up
// to 0.5e-6 — the tolerance has to clear that or every round-trip reads as
// "changed".
const COORDINATE_EPSILON = 1e-6;

export const coordinatesEqual = (
  a: LocationMapCoordinates,
  b: LocationMapCoordinates,
): boolean =>
  Math.abs(a.latitude - b.latitude) < COORDINATE_EPSILON &&
  Math.abs(a.longitude - b.longitude) < COORDINATE_EPSILON;

export const addressFieldsEqual = (
  a: LocationMapAddressFields,
  b: LocationMapAddressFields,
): boolean =>
  a.address === b.address &&
  a.city === b.city &&
  a.postalCode === b.postalCode &&
  a.country === b.country;
